import { render } from "./FormIc.vue?vue&type=template&id=5d26ba80"
import script from "./FormIc.vue?vue&type=script&lang=js"
export * from "./FormIc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__